import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ClinicForm } from '@models/forms/clinic-form';
import { FormType } from '@models/forms/form-type.enum';
import { ServiceTemplateForm } from '@models/forms/service-template-form';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClinicFormService } from '@services/form.service';
import { PatientFormService } from '@services/patient-form.service';
import { Subject, combineLatest } from 'rxjs';
import { startWith, takeUntil } from 'rxjs/operators';

interface FormTypeGroup {
  name: string;
  forms: ClinicForm[];
}

@Component({
  selector: 'app-assign-clinic-form',
  templateUrl: './assign-clinic-form.component.html',
  styleUrls: ['./assign-clinic-form.component.less'],
})
export class AssignClinicFormComponent implements OnInit, OnDestroy {
  unsub: Subject<void>;
  searchFormControl: FormControl;
  formItemGroups: FormTypeGroup[];
  assignedServiceForms: ServiceTemplateForm[];
  loading = false;

  constructor(
    public activeModal: NgbActiveModal,
    private clinicFormService: ClinicFormService,
    private patientFormService: PatientFormService
  ) {}

  ngOnInit() {
    this.unsub = new Subject();
    this.loading = true;
    this.searchFormControl = new FormControl('');

    combineLatest([
      this.clinicFormService.getForms(false, [FormType.Consent, FormType.Intake, FormType.Other]),
      this.patientFormService.patientForms$,
      this.searchFormControl.valueChanges.pipe(startWith('')),
    ])
      .pipe(takeUntil(this.unsub))
      .subscribe(([forms, patientForms, searchString]) => {
        const searchedForms = this.filterForms(forms, searchString);

        for (let form of searchedForms) {
          if (this.assignedServiceForms) {
            form['assigned'] = this.assignedServiceForms.some((sf) => sf.clinicFormId == form.id);
          } else if (patientForms) {
            form['assigned'] = patientForms.some((pf) => pf.clinicFormId == form.id && pf.isSigned == false);
          } else {
            form['assigned'] = false;
          }
        }

        this.formItemGroups = Object.keys(FormType).map((ft) => ({
          name: ft,
          forms: searchedForms.filter((form) => form.formType === FormType[ft]),
        }));

        this.loading = false;
      });
  }

  closeModal(form: ClinicForm) {
    this.activeModal.close(form);
  }

  filterForms(forms: ClinicForm[], searchString: string) {
    if (!searchString) return forms.slice();
    searchString = searchString.toLocaleLowerCase();
    return forms.filter((form) => form.name.toLocaleLowerCase().includes(searchString));
  }

  ngOnDestroy() {
    this.unsub.next();
    this.unsub.complete();
  }
}
